<template>
  <div class="s-flexdrive-exclusives-slick">
    <div class="page-container">
      <SlickCarousel
        ref="slick"
        :key="'key-' + slickKey"
        class="s-flexdrive-exclusives-slick__slick"
        :options="slickOptions"
        @init="onInit"
        @beforechange="onBeforeChange">
        <div
          v-for="(item, index) in records"
          :key="index"
          class="s-flexdrive-exclusives-slick__slide item">
          <div class="b-win-card">
            <div class="b-win-card__body">
              <div class="b-win-card__picture">
                <LazyImage v-if="item.image" :image="item.image" />
              </div>
              <div class="b-win-card__main">
                <div class="b-win-card__title h4">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </SlickCarousel>
    </div>
  </div>
</template>

<script>
import * as lib from '../../lib/lib'
import SlickCarousel from '../components/common/SlickCarousel.vue'
import LazyImage from './../components/common/LazyImage.vue'

export default {
  components: { LazyImage, SlickCarousel },

  data() {
    return {
      records: [],
      slickKey: 0,
      slickOptions: {
        infinite: false,
        autoplay: false,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true,
      },
    }
  },
  mounted() {
    const { records } = lib.getData('flexdriveExclusivesData')
    this.records = records
  },
}
</script>
